import { ProjectFeature } from '@civilgrid/utils/src/common/featureAccess';

export interface FeatureMeta {
  label: string;
  description: string;
  /** Short, end-user-facing summary of what toggling the feature does (tab visibility + export impact). */
  effect: string;
}

// Friendly admin labels for every gateable feature. Mockup names used where given.
// Shared by the Feature Provisioning editor and the Subscription History status view so both use one
// source for feature display names.
export const FEATURE_META: Record<ProjectFeature, FeatureMeta> = {
  [ProjectFeature.Utilities]: {
    label: 'Utility Layer Access',
    description: 'Underground & jurisdictional map layers',
    effect: 'Shows/hides the Utilities tab & its map layers',
  },
  [ProjectFeature.Downloads]: {
    label: 'Digital Downloads',
    description: 'Export layer data / shapefiles',
    effect: 'Shows/hides Download tabs; blocks CAD/GIS exports when off',
  },
  [ProjectFeature.FieldNotes]: {
    label: 'Field Notes',
    description: 'Capture & sync notes from the field',
    effect: 'Shows/hides the Field Notes tab',
  },
  [ProjectFeature.CivilSearch]: {
    label: 'CivilSearch',
    description: 'Agency data request workflow',
    effect: 'Shows/hides CivilSearch agency requests',
  },
  [ProjectFeature.Potholing]: {
    label: 'Potholing',
    description: 'Request & track potholing / locate',
    effect: 'Shows/hides the Potholing tab',
  },
  [ProjectFeature.Intelligence]: {
    label: 'Intelligence',
    description: 'Moratoriums, permits, agency research',
    effect: 'Shows/hides the Intelligence tab',
  },
  [ProjectFeature.Digitization]: {
    label: 'Digitization',
    description: 'Unlimited utility digitization',
    effect: 'Enables/disables utility digitization',
  },
  [ProjectFeature.LandRights]: {
    label: 'Land Rights & Zoning',
    description: 'Parcel ownership & zoning',
    effect: 'Shows/hides the Land Rights & Zoning tab',
  },
  [ProjectFeature.Zoning]: {
    label: 'Zoning',
    description: 'Full project zoning analysis',
    effect: 'Shows/hides the Zoning tab',
  },
  [ProjectFeature.AntennaMap]: {
    label: 'Antenna Map',
    description: 'Wireless antenna siting',
    effect: 'Shows/hides the Antenna Map tab',
  },
  [ProjectFeature.EnvironmentalStudies]: {
    label: 'Environmental Study Data',
    description: 'Environmental study datasets',
    effect: 'Shows/hides the Environmental Study Data tab',
  },
  [ProjectFeature.Geotechnical]: {
    label: 'Geotechnical',
    description: 'Geotechnical reports & borings',
    effect: 'Shows/hides the Geotechnical tab',
  },
  [ProjectFeature.Environmental]: {
    label: 'Environmental',
    description: 'Environmental constraints',
    effect: 'Shows/hides the Environmental tab',
  },
  [ProjectFeature.UtilitiesReports]: {
    label: 'Utility Reports',
    description: 'Generated utility reports',
    effect: 'Shows/hides Utility Reports & their CSV exports',
  },
  [ProjectFeature.UtilitiesNotifications]: {
    label: 'Utility Notifications',
    description: 'Notification preferences',
    effect: 'Shows/hides Utilities Notification Preferences',
  },
  [ProjectFeature.ProposalPacket]: {
    label: 'Proposal Packet',
    description: 'Proposal packet generation',
    effect: 'Shows/hides Proposal Packet & its export',
  },
  [ProjectFeature.Billing]: {
    label: 'Billing',
    description: 'Project billing & transactions',
    effect: 'Shows/hides the Billing tab',
  },
  [ProjectFeature.Summary]: {
    label: 'Summary',
    description: 'Project summary view',
    effect: 'Shows/hides the Summary tab',
  },
};
